import React, {Component} from 'react';
import './SupotsuCalender.css'

export default class SupotsuCalender extends Component{
  constructor(props){
    super(props)
    this.date = new Date();
    this.months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July ',
        'August',
        'September',
        'October',
        'November',
        'December'
      ];
    this.state = {
      days:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],
      current:{
        date:this.date.getDate(),
        year:this.date.getFullYear(),
        month:this.months[this.date.getMonth()],
        index:this.date.getMonth(),
        lastDay:this.getLastDay(this.date.getDate(),this.date.getMonth())
      },
      dates:this.genDays(this.date.getFullYear(),this.date.getMonth()+1),
      date:""
    }

  }

  getLastDay(year,month){
    var year = this.date.getFullYear()
    var date = new Date(year,this.date.getMonth()+1,0)
    return date.getDate()
  }

  prev(int){
    if(this.state.current.index===0){
      var year = parseInt(this.state.current.year)-1
      this.setState({
        current:{
          date:this.date.getDate(),
          year:year,
          month:this.months[11],
          index:11,
          lastDay:this.getLastDay(year,12)
        },
        dates:this.genDays(year,13)
      })
    } else{
      var year = this.state.current.year
      this.setState({
        current:{
          date:this.date.getDate(),
          year:year,
          month:this.months[int],
          index:int,
          lastDay:this.getLastDay(year,int)
        },
        dates:this.genDays(year,int+1)
      })
    }
  }

  next(int){
    if(this.state.current.index===11){
      var year = parseInt(this.state.current.year)+1
      this.setState({
        current:{
          date:this.date.getDate(),
          year:year,
          month:this.months[0],
          index:0,
          lastDay:this.getLastDay(year,1)
        },
        dates:this.genDays(year,2)
      })
    } else{
      var year = this.state.current.year
      this.setState({
        current:{
          date:this.date.getDate(),
          year:year,
          month:this.months[int],
          index:int,
          lastDay:this.getLastDay(year,int)
        },
        dates:this.genDays(year,int+1)
      })
    }
  }

  genDays(year,month,isUpdate){
    var date = new Date(year,month,0)
    var firstDay = new Date(year,month-1,1)
    var startDay = firstDay.getDay()
    const arr = []
    for(let i=0;i<date.getDate()+startDay;i++){
      if(i<startDay){
        arr.push({
          id:null,
          value:i
        })
      } else{
        const bool = Boolean(isUpdate)
        const events = this.getEvents(year,month,i-startDay,bool)
        arr.push({
          id:i,
          value:i-startDay,
          events:events
        })
      }

    }



    return arr
  }

  getEvents(year,month,day,isUpdate){
    const arr = []
    const d = (isUpdate)?day:(day+1)
    this.props.events.forEach((item,i)=>{
      if(item.year===year&&item.month===month&&item.day===(d)){
        //console.log("found");
        arr.push(item)
      } else {

      }
    })

    return arr;
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.date===""||nextProps.date===this.state.date){
      return
    }
    const date = nextProps.date.split("/");
    const dayFor = parseInt(date[1])
    const monthFor = parseInt(date[0])
    this.setState({
      current:{
        date:dayFor,
        year:date[2],
        month:this.months[monthFor-1],
        index:(monthFor-1),
        lastDay:this.getLastDay(date[2],monthFor+1)
      },
      dates:this.genDays(date[2],monthFor, true),
      date:nextProps.date
    })
  }

  render(){
    const days = this.state.dates
    return(
      <div className="supotsu-cal">
        <div className="supotsu-cal-header">
          <i className="icon left" onClick={()=>{
              this.prev(this.state.current.index-1)
            }}></i>
          <span>{this.state.current.month+", "+this.state.current.year}</span>
          <i className="icon right" onClick={()=>{
              this.next(this.state.current.index+1)
            }}></i>
        </div>
        <div className="supotsu-cal-days">
          {
            this.state.days.map((item,i)=>{
              return(
                <span key={i}>{item}</span>
              )
            })
          }
        </div>
        <div className="supotsu-cal-dates">
          {
            days.map((item,i)=>{
              return(
                <div key={i} data-value={item.value+1} className={(item.id===null)?"past":(item.events.length>0)?"has-events":""}>{(item.id===null)?"-":item.value+1}</div>
              )
            })
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SupotsuCalender.js